import GeneratedCodeRenew from './GeneratedCodeRenew'
export default GeneratedCodeRenew